module.exports = __webpack_public_path__ + "img/contacto.25951522.png";